// extracted by mini-css-extract-plugin
export var fadeInAnimation = "Image-module--fadeInAnimation--393ba";
export var item = "Image-module--item--2090d";
export var picture = "Image-module--picture--f1460";